import type { cartTranslations } from '@/i18n';

interface CartFooterProps {
  total: number;
  mode: 'pickup' | 'table';
  t: typeof cartTranslations['ko'];
  formatCurrency: (amount: number) => string;
  onCheckout: () => void;
  onTableOrder: () => void;
}

/**
 * 장바구니 푸터 컴포넌트
 * - 총 금액 표시
 * - 체크아웃/주문 버튼
 */
export function CartFooter({
  total,
  mode,
  t,
  formatCurrency,
  onCheckout,
  onTableOrder,
}: CartFooterProps) {
  const handleButtonClick = () => {
    if (mode === 'table') {
      // 테이블 주문 모드: 주문 확인 모달 표시
      onTableOrder();
    } else {
      // 픽업 모드: 결제 페이지로 이동
      onCheckout();
    }
  };

  return (
    <div className="sticky bottom-0 bg-background border-t border-border shadow-lg">
      {/* 총 금액 섹션 */}
      <div className="px-[clamp(20px,5vw,24px)] py-[clamp(16px,4vw,20px)]">
        <div className="flex items-center justify-between mb-[clamp(16px,4vw,20px)] font-bold">
          <span className="font-['Noto_Sans:Medium',_sans-serif] text-[clamp(16px,4vw,18px)] text-foreground">
            {t.total}
          </span>
          <span className="font-['Noto_Sans:Bold',_sans-serif] text-[clamp(18px,4.5vw,20px)] text-primary">
            {formatCurrency(total)}
          </span>
        </div>

        {/* 체크아웃 버튼 */}
        <button
          onClick={handleButtonClick}
          className="w-full bg-primary hover:bg-primary-hover text-white font-['Noto_Sans:Bold',_sans-serif] text-[clamp(16px,4vw,18px)] h-[50px] rounded-[5px] transition-all duration-200 active:scale-[0.98] shadow-md hover:shadow-lg text-center flex items-center justify-center"
        >
          {t.checkout}
        </button>
      </div>
    </div>
  );
}
